<template>
 <Row :style="treeStyle">
  <!--    <Tree size="small" @on-check-change="onTreeCheckChange" style="overflow: hidden;"-->
  <!--          :data="groupVehicleInfoTree"-->
  <!--          :load-data="onLoadChildrenGroupData" :render="renderContent"></Tree>-->

   <AutoComplete
     size="small"
     @on-change="changedata3"
     clearable
     v-model="registrationNum"
     :data="data3"
     :filter-method="filterMethod"
     @on-select="selectvehicle"
     placeholder="车牌号"
     style="width: 190px;">
   </AutoComplete>

  <Tree size="small" ref="tree" :data="groupVehicleInfoTree" :render="renderContent"  @on-select-change="onvehicleinfo"
        show-checkbox class="demo-tree-render" :load-data="onLoadChildrenGroupData"
        @on-check-change="onTreeCheckChange"></Tree>
  <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center; z-index: 500;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="vehicleListLoadding">
   <Spin size="large"></Spin>
   <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
  </div>
 </Row>
</template>
<script>

import Vue from 'vue'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import Icons from '_c/icons'
import store from '@/store'
import { registrationTextColor, registrationColor } from '@/libs/registrationutil'
import { isAccOn, explainDirection, explainState, explainAlarmSign } from '@/libs/jt808util'
import { stringToByte } from '@/libs/stringutil'

export default {
  name: 'vehicleinfogrouptree',
  components: {
    Icons
  },
  props: {
    vehicleDymaicManager: {
      require: true
    }
  },
  data () {
    return {
      registrationNum: '',
      data3: [],

      vehicleListLoadding: false,
      // 树结构 -----------------------------------
      allcheckedVehicleInfos: [],
      checkedVehicleInfos: [],
      lastcheckedVehicleInfos: [],
      treeHeight: 100,
      treeStyle: {
        'padding-left': '20px',
        'background-color': '#ffff',
        height: '100%',
        overflow: 'auto'
      },
      groupVehicleInfoTree: [{
        title: '所有车辆',
        expand: true,
        isGroup: true,
        children: [
          {
            title: '挂载车辆',
            expand: false,
            loading: false,
            isGroup: true,
            children: []
          },
          {
            title: '挂载分组',
            expand: false,
            loading: false,
            isGroup: true,
            children: []
          }
        ]
      }]
    }
  },
  methods: {
    /**
     * 搜索车牌订阅
     */
    changedata3 () {
      let t = null
      if (t !== null){
        clearTimeout(t)
      }
      t = setTimeout(()=>{
          console.log(this.registrationNum)
      if (!this.registrationNum || this.registrationNum === '') {
      } else {
        store.dispatch('VehicleInfoServ_SearchByName', {
          params: {
            name:this.registrationNum
          },
          urlparams: null
        }).then(res => {
      this.data3 = []
          this.list = res.data

          let result = []
          for (let i = 0; i < this.list.length; i++) {
            let str = this.list[i].registrationNum === null ? this.list[i].vin : this.list[i].registrationNum
            if (str.toUpperCase().indexOf(this.registrationNum.toUpperCase()) !== -1) {
              result.push(str)
            }

            if (this.list[i].customName) {
              let str1 = this.list[i].customName
              if (str1.toUpperCase().indexOf(this.registrationNum.toUpperCase()) !== -1) {
                result.push(str1)
              }
            }
          }
          let length = result.length > 10 ? 10 : result.length
          for (let i = 0; i < length; i++) {
            this.data3.push(result[i])
          }
        }).catch(err => {
          this.$Message.error(err)
        })
      }
        }
        ,2000)
    },

    filterMethod () {
      this.onSearchClickdisabled = false

      return true
    },
    selectvehicle(e){
      console.log(e)
      store.dispatch('VehicleInfoServ_SearchByName', {
        params: {
          name:e
        },
        urlparams: null
      }).then(res => {
        let VehicleInfoByTerminalNum = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(res.data[0].positioningDeviceInfos[0].terminalNum)
        console.log(VehicleInfoByTerminalNum)
        if (VehicleInfoByTerminalNum){
          console.log('已订阅')
          console.log(this.checkedVehicleInfos)
          if (this.checkedVehicleInfos.length >0){
                      this.checkedVehicleInfos.forEach(item =>{
console.log(item)
          if (item.positioningDeviceInfos[0].terminalNum == VehicleInfoByTerminalNum.positioningDeviceInfos[0].terminalNum){

          let positioningDeviceInfos = []
          positioningDeviceInfos.push(VehicleInfoByTerminalNum.positioningDeviceInfos[0])
          this.onvehicleinfo(positioningDeviceInfos)
          }else{
            console.log(item)

            this.checkedVehicleInfos.push(VehicleInfoByTerminalNum)
let newvehiclelist = []
            newvehiclelist.push(VehicleInfoByTerminalNum)
            this.vehicleDymaicManager.subscribeDymaicData(newvehiclelist, true)
          }
          })
          } else {
            this.checkedVehicleInfos.push(VehicleInfoByTerminalNum)
            this.vehicleDymaicManager.subscribeDymaicData(this.checkedVehicleInfos, true)

          }
          // for (let i = 0; i < this.checkedVehicleInfos.length; i++) {
          //   console.log(this.checkedVehicleInfos[i])
          //   if (this.checkedVehicleInfos[i].positioningDeviceInfos[0].terminalNum == VehicleInfoByTerminalNum.positioningDeviceInfos[0].terminalNum){
          // console.log('加载订阅')
            //
            //   let positioningDeviceInfos = []
            //   positioningDeviceInfos.push(VehicleInfoByTerminalNum.positioningDeviceInfos[0])
            //   this.onvehicleinfo(positioningDeviceInfos)
            // }else{
            //   console.log(this.checkedVehicleInfos[i])
            //
            //   this.checkedVehicleInfos.push(VehicleInfoByTerminalNum)
            //   let newvehiclelist = []
            //   newvehiclelist.push(VehicleInfoByTerminalNum)
            //   this.vehicleDymaicManager.subscribeDymaicData(newvehiclelist, true)
            // }
          // }

        }else {
          console.log('未订阅')
          this.vehicleDymaicManager.putVehicleInfo(res.data)
          let vehicleInfo = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(res.data[0].positioningDeviceInfos[0].terminalNum)
          console.log(vehicleInfo)
          if (vehicleInfo) {
            this.checkedVehicleInfos.push(vehicleInfo)
          }
          this.vehicleDymaicManager.subscribeDymaicData(this.checkedVehicleInfos, true)
        }
      }).catch(err=>{
        this.$Message.error(err)
      })
    },

    /** --------------------------------------------------
    * 方法部分
    */

    onvehicleinfo (e) {
      console.log(e)
      this.$emit('onvehicleinfo', e.pop())
    },

    /**
    * 单独车辆或车组取消订阅
    * 功能实现了，代码不详，一脸懵逼
    * @ jlliang
    */
    deleteVehcile () {
    // this.lastcheckedVehicleInfos=[]
    // this.checkedVehicleInfos.forEach(item=>{
    //  this.lastcheckedVehicleInfos.push(item)
    // })
      console.log(this.lastcheckedVehicleInfos)
      console.log(this.checkedVehicleInfos)
      if (this.lastcheckedVehicleInfos.length > this.checkedVehicleInfos.length) {
        console.log('执行单独取消订阅')
        for (let j = 0; j < this.checkedVehicleInfos.length; j++) {
          console.log('执行单独取消订阅1')
          console.log(this.checkedVehicleInfos[j])

          // this.checkedVehicleInfos.forEach(checkedVehicleInfos => {
          // console.log(checkedVehicleInfos)
          for (let i = 0; i < this.lastcheckedVehicleInfos.length; i++) {
            console.log('执行单独取消订阅2')
            console.log(this.lastcheckedVehicleInfos[i])
            if (this.checkedVehicleInfos[j].id == this.lastcheckedVehicleInfos[i].id) {
              this.lastcheckedVehicleInfos.splice(i, 1)
            }
          }
          // })
        }
        this.vehicleDymaicManager.cancelSubscribeVehicles(this.lastcheckedVehicleInfos)
      }
      /**
     * @ jlliang
     * 懵逼地方，迷之操作
     */
      // 单独分组的取消订阅
      console.log(this.lastcheckedVehicleInfos)
      for (let i = 0; i < this.lastcheckedVehicleInfos.length; i++) {
        for (let k = 0; k < this.allcheckedVehicleInfos.length; k++) {
          if (this.lastcheckedVehicleInfos[i].id == this.allcheckedVehicleInfos[k].id) {
            this.allcheckedVehicleInfos.splice(k, 1)
          }
        }
      }
      console.log(this.checkedVehicleInfos)
      console.log(this.allcheckedVehicleInfos)
      for (let i = 0; i < this.checkedVehicleInfos.length; i++) {
        this.allcheckedVehicleInfos.forEach(item => {
          if (item.id == this.vehicleDymaicManager[i].id) {
            this.checkedVehicleInfos.splice(i, 1)
          }
        })
      }
      console.log(this.lastcheckedVehicleInfos)
    },

    /**
    * 车辆列表选择回调函数
    * @param selectArray
    */
    onTreeCheckChange (selectArray) {
      console.log(selectArray)
      console.log(this.checkedVehicleInfos)
      this.lastcheckedVehicleInfos = []
      this.checkedVehicleInfos.forEach(item => {
        this.lastcheckedVehicleInfos.push(item)
      })
      // this.lastcheckedVehicleInfos= JSON.parse(JSON.stringify(this.checkedVehicleInfos))
      this.vehicleListLoadding = true
      let list = []
      if (selectArray.length > 0) {
        // if (this.checkedVehicleInfos.length>selectArray.length) {
        //  selectArray.forEach(selectArrayindex => {
        //   this.checkedVehicleInfos.forEach(lastselectArrayindex => {
        //
        //   })
        //  })
        // }
        selectArray.forEach(selectArrayindex => {
          if (selectArrayindex.title === '挂载分组') {
            console.log('加载挂载分组')
            this.checkedVehicleInfos = []

            // 订阅全部分组车辆
            store.dispatch('VehicleInfoGroupServ_GetDirectlyUnderBindAll', {
              params: null,
              urlparams: null
            }).then(res => {
              // 订阅列表
              // console.log(res)
              if (store.getters.get_VehicleInfoGroup_GetDirectlyUnderBindAllResult) {
                store.getters.get_VehicleInfoGroup_GetDirectlyUnderBindAllResult.forEach(vehiclegroup => {
                  store.dispatch('VehicleInfoServ_GetGroupRecursiveAll', {
                    params: {
                      groupId: vehiclegroup.id
                    },
                    urlparams: null
                  }).then(() => {
                    if (store.getters.get_VehicleInfo_GetGroupRecursiveAllResult) {
                      store.getters.get_VehicleInfo_GetGroupRecursiveAllResult.forEach(vehicle => {
                        if (vehicle.positioningDeviceInfos) {
                          // 订阅列表
                          list.push(vehicle)
                          this.vehicleDymaicManager.putVehicleInfo(list)
                          let vehicleInfo = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(vehicle.positioningDeviceInfos[0].terminalNum)
                          if (vehicleInfo) {
                            this.checkedVehicleInfos.push(vehicleInfo)
                          }
                          this.vehicleDymaicManager.subscribeDymaicData(this.checkedVehicleInfos, true)
                          this.saveRealtimeMonitorSubscribe()

                          this.vehicleListLoadding = false
                        }
                      })
                    }
                  }).catch(err => {
                    console.log(err)
                  })
                })
              }
            }).catch(err => {
              console.log(err)
            })
          } else if (selectArrayindex.title === '挂载车辆') {
            console.log('加载挂载车辆')
            this.checkedVehicleInfos = []
            store.dispatch('VehicleInfoServ_GetDirectlyUnderBindAll', {
              params: null,
              urlparams: null
            }).then(() => {
              // console.log(store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult)
              // this.vehicleDymaicManager.putVehicleInfo(store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult)
              if (store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult) {
                store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult.forEach(vehicle => {
                  // console.log(vehicle)
                  if (vehicle.positioningDeviceInfos) {
                    // 订阅列表
                    list.push(vehicle)
                    // console.log(list)
                    this.vehicleDymaicManager.putVehicleInfo(list)
                    let vehicleInfo = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(vehicle.positioningDeviceInfos[0].terminalNum)
                    if (vehicleInfo) {
                      this.checkedVehicleInfos.push(vehicleInfo)
                    }
                    this.vehicleDymaicManager.subscribeDymaicData(this.checkedVehicleInfos, true)
                    this.saveRealtimeMonitorSubscribe()

                    this.vehicleListLoadding = false
                  }
                })
              }
            }).catch(err => {
              this.$Message.error(err)
              console.log(err)
            })
          } else if (selectArrayindex.title === '所有车辆') {
            console.log('加载所有车辆')
            this.checkedVehicleInfos = []

            store.dispatch('VehicleInfoServ_GetBindAll', {
              params: null,
              urlparams: null
            }).then(() => {
              // console.log(store.getters.get_VehicleInfo_GetBindAllResult)
              // this.vehicleDymaicManager.putVehicleInfo(store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult)
              if (store.getters.get_VehicleInfo_GetBindAllResult) {
                store.getters.get_VehicleInfo_GetBindAllResult.forEach(vehicle => {
                  // console.log(vehicle)
                  if (vehicle.positioningDeviceInfos) {
                    // 订阅列表
                    list.push(vehicle)
                    // console.log(list)
                    this.vehicleDymaicManager.putVehicleInfo(list)
                    let vehicleInfo = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(vehicle.positioningDeviceInfos[0].terminalNum)
                    if (vehicleInfo) {
                      this.checkedVehicleInfos.push(vehicleInfo)
                    }
                    this.vehicleDymaicManager.subscribeDymaicData(this.checkedVehicleInfos, true)
                    this.saveRealtimeMonitorSubscribe()

                    this.vehicleListLoadding = false
                  }
                })
              }
            }).catch(err => {
              this.$Message.error(err)
              console.log(err)
            })
          } else {
            this.checkedVehicleInfos = []

            if (selectArrayindex.isGroup) {
              store.dispatch('VehicleInfoServ_GetGroupRecursiveAll', {
                params: {
                  groupId: selectArrayindex.id
                },
                urlparams: null
              }).then(() => {
                if (store.getters.get_VehicleInfo_GetGroupRecursiveAllResult) {
                  store.getters.get_VehicleInfo_GetGroupRecursiveAllResult.forEach(vehicle => {
                    if (vehicle.positioningDeviceInfos) {
                      // 订阅列表
                      list.push(vehicle)
                      this.vehicleDymaicManager.putVehicleInfo(list)
                      let vehicleInfo = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(vehicle.positioningDeviceInfos[0].terminalNum)
                      if (vehicleInfo) {
                        this.checkedVehicleInfos.push(vehicleInfo)
                      }
                      this.vehicleDymaicManager.subscribeDymaicData(this.checkedVehicleInfos, true)
                      this.saveRealtimeMonitorSubscribe()

                      this.vehicleListLoadding = false
                    }
                  })
                }
              }).catch(err => {
                this.$Message.error(err)
                console.log(err)
              })
            } else {
              store.dispatch('VehicleInfoServ_GetDetail', {
                params: {
                  id: selectArrayindex.id
                },
                urlparams: null
              }).then(() => {
                // console.log(store.getters.get_VehicleInfo_GetDetailResult)
                if (store.getters.get_VehicleInfo_GetDetailResult) {
                  if (store.getters.get_VehicleInfo_GetDetailResult.positioningDeviceInfos) {
                    list.push(store.getters.get_VehicleInfo_GetDetailResult)
                    this.vehicleDymaicManager.putVehicleInfo(list)
                    let vehicleInfo = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(store.getters.get_VehicleInfo_GetDetailResult.positioningDeviceInfos[0].terminalNum)
                    if (vehicleInfo) {
                      this.checkedVehicleInfos.push(vehicleInfo)
                    }
                    this.vehicleDymaicManager.subscribeDymaicData(this.checkedVehicleInfos, true)
                    this.saveRealtimeMonitorSubscribe()

                    this.vehicleListLoadding = false
                  }
                }
              }).catch(err => {
                console.log(err)
              })
            }
          }
        })
      } else {
        // console.log(this.checkedVehicleInfos)
        this.vehicleDymaicManager.cancelSubscribeVehicles(this.checkedVehicleInfos)
        this.clearBigDataTable()
        this.checkedVehicleInfos = []
      }

      setTimeout(()=>{
       this.checkedVehicleInfos.forEach(item=>{
       this.allcheckedVehicleInfos
       })
      this.deleteVehcile()
      }
       ,1000)

      this.saveRealtimeMonitorSubscribe()

    // this.checkedVehicleInfos = []
    // selectArray.forEach(item => {
    //  // 不能直接将vehicleInfo绑在node上，会出现循环调用报错
    //  let vehicleInfo = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(item.terminalNum)
    //  if (vehicleInfo) {
    //   this.checkedVehicleInfos.push(vehicleInfo)
    //  }
    // })
    },
    saveRealtimeMonitorSubscribe () {
      console.log('保存订阅列表缓存')
      // 保存订阅列表缓存
      if (!this.vehicleDymaicManager.subscribedVehicleInfos) {
        return
      }
      let list = []
      this.vehicleDymaicManager.subscribedVehicleInfos.forEach(item => {
        let v = {
          id: item.id,
          registrationNum: item.registrationNum,
          registrationColor: item.registrationColor,
          vin: item.vin,
          customName: item.customName,
          positioningDeviceInfos: []
        }
        if (item.positioningDeviceInfos && item.positioningDeviceInfos.length > 0) {
          item.positioningDeviceInfos.forEach(p => {
            v.positioningDeviceInfos.push({
              id: p.id,
              terminalNum: p.terminalNum
            })
          })
        }
        list.push(v)
      })
      store.dispatch('RealtimeMonitorSubscribeServ_SaveRealtimeMonitorSubscribe', {
        params: { subscribeList: JSON.stringify(list) },
        urlparams: null
      }).then(() => {
        console.log('保存订阅列表缓存成功')
      }).catch(err => {
        this.$Message.error(err)
        console.log(err)
      })
    },

    clearBigDataTable () {
      this.$emit('clearBigDataTable')
      this.vehicleListLoadding = false
    },
    clearCheckedNodes () {
    // console.log(this.$refs.tree.getCheckedNodes())
      this.$refs.tree.getCheckedNodes().forEach(checkindex => {
        checkindex.checked = false
        this.vehicleListLoadding = false
      })
      console.log(this.$refs.tree.getCheckedAndIndeterminateNodes())
      this.$refs.tree.getCheckedAndIndeterminateNodes().forEach(checkindex => {
        checkindex.indeterminate = false
        this.vehicleListLoadding = false
      })
    },

    /**
    * 树节点渲染回调函数
    * @param h
    * @param root
    * @param node
    * @param data
    * @returns {*}
    */
    renderContent (h, { root, node, data }) {
    // let iconStr = null
      let style = null
      if (data.isGroup) {
        // iconStr = 'md-folder'
        style = {}
      } else {
        let vehicleInfo = this.vehicleDymaicManager.findVehicleInfoByTerminalNum(data.terminalNum)
        let vehicleInfoRegistrationNum = vehicleInfo == null ? null : vehicleInfo.registrationNum
        let vehicleInfoRegistrationColor = vehicleInfo == null ? null : vehicleInfo.registrationColor
        // iconStr = 'md-car'
        style = {
          backgroundColor: vehicleInfoRegistrationNum === null ? null : registrationColor(vehicleInfoRegistrationColor),
          color: vehicleInfoRegistrationNum === null ? '#000000' : registrationTextColor(vehicleInfoRegistrationColor),
          'padding-left': '5px',
          'padding-right': '5px',
          'padding-top': '2px',
          'padding-bottom': '2px',
          'border-radius': '3px'
        }
      }
      return h('span', {
        style: {
          display: 'inline-block',
          width: '100%'
        }
      }, [
        h('span', [
          h('Icon', {
            props: {
              // type: iconStr
            },
            style: {
              marginRight: '3px'
            }
          }),
          h('span', {
            style: style,
            on: {
              click: () => {
                // this.onGroupClick(data)
              }
            }
          }, data.title)
        ])
      ])
    },

    /**
    * 分组文件夹点击事件
    * 当分组文件夹点击时请求加载车辆数据
    * 参数 data:树结构节点数据
    */
    onGroupClick (data) {
      if (data.title === '挂载车辆') {
        console.log('加载挂载车辆')
        this.$emit('onLoadDirectlyUnderBindVehicleInfos')
      } else if (data.title === '挂载分组') {
        console.log('加载挂载分组')
      } else if (data.title === '所有车辆') {
        console.log('加载所有车辆')
        this.$emit('onLoadAllVehicleInfos')
      } else {
        if (data.id) {
          console.log('加载车辆')
          this.$emit('onLoadVehicleInfosByGroupId', data.id)
        }
      }
    },

    /**
    * 加载子节点回调函数
    * @param item
    * @param callback
    */
    onLoadChildrenGroupData (item, callback) {
      let tempData = []
      if (item.title === '挂载车辆') {
        store.dispatch('VehicleInfoServ_GetDirectlyUnderBindAll', {
          parmas: null,
          urlparmas: null
        }).then(() => {
          if (store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult && item.children.length == 0) {
            store.getters.get_VehicleInfo_GetDirectlyUnderBindAllResult.forEach(vehicleInfoItem => {
              if (vehicleInfoItem.positioningDeviceInfos) {
                item.children.push(
                  {
                    id: vehicleInfoItem.id,
                    title: vehicleInfoItem.registrationNum,
                    expand: false,
                    // loading: false,
                    // children: [],
                    isGroup: false,
                    parent: item,
                    terminalNum: vehicleInfoItem.positioningDeviceInfos[0].terminalNum
                  }
                )
              } else {
                item.children.push(
                  {
                    id: vehicleInfoItem.id,
                    title: vehicleInfoItem.registrationNum,
                    expand: false,
                    // loading: false,
                    // children: [],
                    isGroup: false,
                    parent: item,
                    terminalNum: null
                  }
                )
              }
            })
          }
        }).catch(err => {
          this.$Message.error(err)
          console.log(err)
        })
        callback(tempData)
      } else if (item.title === '挂载分组') {
        store.dispatch('VehicleInfoGroupServ_GetRootVehicleInfoGroups', {
          params: null,
          urlparams: null
        }).then(() => {
          if (store.getters.get_VehicleInfoGroup_GetRootVehicleInfoGroupsResult) {
            store.getters.get_VehicleInfoGroup_GetRootVehicleInfoGroupsResult.forEach(vehicleInfoGroupItem => {
              tempData.push(
                {
                  id: vehicleInfoGroupItem.id,
                  title: vehicleInfoGroupItem.name,
                  expand: false,
                  loading: false,
                  children: [],
                  isGroup: true,
                  parent: item,
                  terminalNum: null
                }
              )
            })
            callback(tempData)
          }
        }).catch(err => {
          this.$Message.error(err)
          console.log(err)
        })
      } else {
        // 先加载子组
        console.log('加载子组')
        store.dispatch('VehicleInfoGroupServ_GetChildrenGroups', {
          params: { id: item.id },
          urlparams: null
        }).then(() => {
          // console.log(store.getters.get_VehicleInfoGroup_GetChildrenGroupsResult)
          if (store.getters.get_VehicleInfoGroup_GetChildrenGroupsResult.length > 0) {
            store.dispatch('VehicleInfoServ_GetByGroupId', {
              params: {
                id: item.id
              },
              urlparmas: null
            }).then(() => {
              // console.log(store.getters.get_VehicleInfo_GetByGroupIdResult)
              // console.log(item)
              if (store.getters.get_VehicleInfo_GetByGroupIdResult) {
                store.getters.get_VehicleInfo_GetByGroupIdResult.forEach(vehicleinfo => {
                  // console.log(vehicleinfo.positioningDeviceInfos)
                  if (vehicleinfo.positioningDeviceInfos != null) {
                    tempData.push(
                      {
                        id: vehicleinfo.id,
                        title: vehicleinfo.registrationNum,
                        expand: false,
                        // loading: false,
                        // children: [],
                        isGroup: false,
                        parent: item,
                        terminalNum: vehicleinfo.positioningDeviceInfos[0].terminalNum
                      }
                    )
                  } else {
                          tempData.push(
                            {
                              id: vehicleinfo.id,
                              title: vehicleinfo.registrationNum,
                              expand: false,
                              // loading: false,
                              // children: [],
                              isGroup: false,
                              parent: item,
                              terminalNum: null
                            }
                          )
                  }

                })
              }
              callback(tempData)
            }).catch(err => {
              this.$Message.error(err)
              console.log(err)
            })
            store.getters.get_VehicleInfoGroup_GetChildrenGroupsResult.forEach(vehicleInfoGroupItem => {
              tempData.push(
                {
                  id: vehicleInfoGroupItem.id,
                  title: vehicleInfoGroupItem.name,
                  expand: false,
                  loading: false,
                  children: [],
                  isGroup: true,
                  parent: item,
                  terminalNum: null
                }
              )
            })
            // callback(tempData)
          } else {
            store.dispatch('VehicleInfoServ_GetByGroupId', {
              params: {
                id: item.id
              },
              urlparmas: null
            }).then(() => {
              if (store.getters.get_VehicleInfo_GetByGroupIdResult) {
                store.getters.get_VehicleInfo_GetByGroupIdResult.forEach(vehicleinfo => {
                  if (vehicleinfo.positioningDeviceInfos) {
                    tempData.push(
                      {
                        id: vehicleinfo.id,
                        title: vehicleinfo.registrationNum,
                        expand: false,
                        // loading: false,
                        // children: [],
                        isGroup: false,
                        parent: item,
                        terminalNum: vehicleinfo.positioningDeviceInfos[0].terminalNum
                      }
                    )
                  } else {
                    tempData.push(
                      {
                        id: vehicleinfo.id,
                        title: vehicleinfo.registrationNum,
                        expand: false,
                        // loading: false,
                        // children: [],
                        isGroup: false,
                        parent: item,
                        terminalNum: null
                      }
                    )
                  }
                })
              }
              callback(tempData)
            }).catch(err => {
              this.$Message.error(err)
              console.log(err)
            })
          }
        }).catch(err => {
          this.$Message.error(err)
          console.log(err)
        })
      }
    }

  },
  computed: {},
  beforeDestroy () {

  },
  mounted () {
    this.$nextTick(() => {
    //
    // console.log(this.groupVehicleInfoTree)
    // store.dispatch('VehicleInfoGroupServ_GetDirectlyUnderBindAll', {
    //  params: null,
    //  urlparams: null
    // }).then(() => {
    //  if (store.getters.get_VehicleInfoGroup_GetDirectlyUnderBindAllResult) {
    //   store.getters.get_VehicleInfoGroup_GetDirectlyUnderBindAllResult.forEach(vehicleInfoGroupItem => {
    //    this.groupVehicleInfoTree[0].children[1].children.push({
    //     id: vehicleInfoGroupItem.id,
    //     title: vehicleInfoGroupItem.name,
    //     expand: false,
    //     loading: false,
    //     children: [],
    //     isGroup: true,
    //     parent: this.groupVehicleInfoTree[0].children[1],
    //     terminalNum: null
    //    })
    //   })
    //  }
    // }).catch(err => {
    //  this.$Message.error(err)
    //  console.log(err)
    // })

    })
  }
}
</script>
